import { render, staticRenderFns } from "./ImagePage.vue?vue&type=template&id=5fe6b152&scoped=true"
import script from "./ImagePage.vue?vue&type=script&lang=ts"
export * from "./ImagePage.vue?vue&type=script&lang=ts"
import style0 from "./ImagePage.vue?vue&type=style&index=0&id=5fe6b152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe6b152",
  null
  
)

export default component.exports